export enum COMM_OF_TYPES {
  Email, Sms
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/comms.ts